import Accordion from 'components/shared/accordion/Accordion';
import { AccordionItemProps } from 'components/shared/accordion/Accordion.types';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { StyledAccordion, StyledLink } from './JuniorsKit.styled';

type ContentProps = {
  content?: any[];
  links?: any[];
};

const JuniorsKitAccordion: React.FC<ContentProps> = ({ content, links }) => {
  const sortedContent = content?.sort(
    (a, b) => a.attributes.order - b.attributes.order
  );

  const sortedLinks = links?.sort(
    (a, b) => a.attributes.order - b.attributes.order
  );

  const items: AccordionItemProps[] | any = sortedContent?.map(
    ({ id, attributes }, index) =>
      attributes.order > 0 && {
        summary: attributes.name,
        details: (
          <div>
            <img
              src={attributes.image.data.attributes.url}
              alt={attributes.name}
            />
            <MarkdownComponent content={attributes.description} />
            {sortedLinks?.map(
              ({ id: idLink, attributes }) =>
                attributes.order > 0 &&
                attributes.helping_junior_section.data &&
                attributes.helping_junior_section.data.id === id && (
                  <StyledLink
                    key={idLink}
                    href={attributes.link}
                    target="_blank"
                  >
                    {attributes.name}
                  </StyledLink>
                )
            )}
          </div>
        ),
        active: index === 0
      }
  );

  return (
    <StyledAccordion>
      <Accordion items={items} />
    </StyledAccordion>
  );
};

export default JuniorsKitAccordion;
